<template>
    <div class="hello" style="background-color:#f4f5f5; height:100%">
    <van-nav-bar title="登出用戶" left-arrow @click-left="gotohome" />
        <div style="text-align:center; max-width:640px; height:auto; margin: 0 auto; padding: 0 auto; padding-top: 10px; ">
            <div>
                <span  style="color: #606266; font-size:15px;font-weight: 900;">小泉士多 KOIZUMISHOP</span>
            </div>
            <div style="margin-top:10px;">
                <van-image width="128px" height="128px" :src=pic fit="fill" round/>
            </div>
        </div>
        <div v-if="login">
            <div style="text-align:center; padding-top: 20px; ">
                <span  style="color: #606266; font-size:0.6rem; margin-left: 20px;">正在退出登入資料...</span>
            </div>

        </div>
        <div style="margin:0 auto; text-align:center; padding-bottom:80px;">
          <span style="color: #606266; font-size:0.6rem;">@小泉士多 KOIZUMISHOP</span>
            <div style="margin-top:20px;">
              <ul style="display: inline-flex;list-style: none;"><li style="margin-right: 14px;"><a style="color:#606266; text-decoration: none;font-size:0.6rem;" href="/privacy">隱私政策</a></li><li><a style="color:#606266; text-decoration: none;font-size:0.6rem;" href="/terms">服務條款</a></li></ul>
            </div>
        </div>
    </div>
</template>
<script>
import { logout } from '@/api/user'
import { getFBToken, getToken, getUser, removeToken, removeUser } from '@/utils/auth'
import { Notify, Toast } from 'vant'

export default {
  name: 'facebook',
  data () {
    return {
      login: true,
      showDatePicker: false,
      minDate: new Date(1940, 0, 1),
      maxDate: new Date(2005, 9, 1),
      pic: '/static/koizumishop.png',
      userData: {},
      fbSignInParams: { scope: 'email,public_profile,user_birthday,user_gender', return_scopes: true },
      redirect: undefined,
      FB: undefined
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  created () {
    console.log(getFBToken())
    window.FB.api('/me', 'GET', { fields: 'id,name,birthday,gender,email,picture', access_token: getFBToken() },
      userInformation => {
        console.log(userInformation)
      }
    )
    window.FB.getLoginStatus(function (response) {
      console.log(response)
      if (response.status === 'connected') {
        window.FB.logout()
      }
    })
    this.onSignInError()
    // winodw.FB.logout()
    console.log(window.FB.getAccessToken())
  },
  methods: {
    gotohome () {
      this.$router.replace({ path: this.redirect || '/' })
      window.scrollTo(0, 0)
    },
    onSignInSuccess (response) {
      // 登录成功回调

      console.log(response) // 返回第三方的登录信息 tolen等
    },
    onConnected (response) {
      console.log(response)
    },
    onSignInError (response) {
      console.log(response)
      this.login = true
      this.pic = '/static/koizumishop.png'
      logout({ user: getUser(), token: getToken() }).then(res => {
        if (res.code === 200) {
          Notify({ type: 'success', message: '登出成功' })
          Toast.success('多謝惠顧')
          removeToken()
          removeUser()
          setTimeout(() => {
            this.gotohome()
          }, 3000)
        } else {
          Notify({ type: 'danger', message: res.message })
          Toast.fail('登出失敗')
          removeToken()
          removeUser()
          this.gotohome()
        }
      })
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fb-signin-button {
  /* This is where you control how the button looks. Be creative! */
  display: inline-block;
  width:90%;
  max-width: 640px;
  padding: 4px 8px;
  border-radius: 3px;
  background-image: linear-gradient(#4C69BA, #3B55A0);
  color: #fff;
}
.date-pop {
  left:auto;
  min-width: 320px;
  max-width:640px;
  background-color:#f4f5f5;
}
</style>



// WEBPACK FOOTER //
// src/components/Logout.vue